// Global SiteList for components that use the related icons.
// Useful to free up space on pages which already have a lot of data

export default {

  EmoryUniversity: 'Emory University',
  JohnsHopkinsUniversity: 'Johns Hopkins University',
  DukeUniversity: 'Duke University',
  UniversityofIowa: 'University of Iowa',
  VanderbiltUniversity: 'Vanderbilt University',
  CaseWesternReserveUniversity: 'Case Western Reserve University',
  UniversityofWashington: 'University of Washington',
  PrimaryPhysiciansResearch: 'Primary Physicians Research',
  StLouisUniversity: 'St. Louis University',
  BaylorCollegeofMedicine: 'Baylor College of Medicine',
  GroupHealthCooperative: 'Group Health Cooperative',
  KernMedical: 'Kern Medical',
  KaiserAntelopeValley: 'Kaiser Antelope Valley',
  KaiserBakersfield: 'Kaiser Bakersfield',
  UnivofAZTucson: 'Univ of AZ-Tucson',
  UnivofAZPhoenix: 'Univ of AZ-Phoenix',
  ChldrensHospitalofPittsburg: "Chldren's Hospital of Pittsburg (SCOUT)",
  DetroitReceivingHospital: 'Detroit Receiving Hospital',
  HarperUniversityHospital: 'Harper University Hospital',
  SiNAiGraceHospital: 'SiN/Ai-Grace Hospital',
  HenryFordHospitalHealthSystem: 'Henry Ford Hospital Health System',
  OhioStateUniversityWexnerMedicalCenter: 'The Ohio State University Wexner Medical Center',
  UniversityofMiamiJacksonMemorialHospital: 'University of Miami/Jackson Memorial Hospital',
  BeaumontHealthSystem: 'Beaumont Health System',
  NewYorkPresbyterian: 'New York Presbyterian',
  SirirajHospital: 'Siriraj Hospital',
  MahidolUniversity: 'Mahidol University',
  FloridaHospital: 'Florida Hospital',
  UCSFFresno: 'UCSF Fresno',
  UniversityofAntioquia: 'University of Antioquia',
  MelendezHealthCenter: 'Melendez Health Center',
  StJudeChildrensResearchHospital: "St. Jude Children's Research Hospital",
  UniversityofWisconsinMadisonSchool: 'University of Wisconsin-Madison School of Vet. Medicine',
  WashingtonUniversitySchoolofMedicine: 'Washington University School of Medicine',
  DukeUniversityHospitalandHealthCenter: 'Duke University Hospital and Health Center',
  DeKalbMedicalHospital: 'DeKalb Medical Hospital',
  UniversityofCincinnati: 'University of Cincinnati',
  UniversityofLouisville: 'University of Louisville',
  UniversityofPittsburgh: 'University of Pittsburgh',
  WilliamBeaumontHospital: 'William Beaumont Hospital',
  EastCarolinaUniversity: 'East Carolina University',
  OregonHealthandScienceUniversity: 'Oregon Health and Science University'

}
